import { SubmitToSandboxPanelWebComponent } from './component/SubmitToSandboxPanelWebComponent';
import { WEB_COMPONENT_SUBMIT_TO_SANDBOX_PANEL } from '../../../webcomponents.constants';

export { SubmitToSandboxPanelWebComponent };

window.customElements.define(WEB_COMPONENT_SUBMIT_TO_SANDBOX_PANEL, SubmitToSandboxPanelWebComponent);
